import { requestApi } from '../util/network'

// 语言列表
export const getLangList =
  () =>
    requestApi(
      '/index/getLangList',
      'POST',
      {
      }
    )

// 切换语言
export const change_lang =
  (lang) =>
    requestApi(
      '/member/change_lang',
      'POST',
      {
        lang
      },
      'member'
    )

// 首页显示的分类
export const Goodsclass =
  () =>
    requestApi(
      '/Goodsclass/index_class',
      'POST',
      {
      }
    )
// 首页显示的分类--get_contact_info
export const get_contact_info =
  () =>
    requestApi(
      '/connect/get_contact_info',
      'GET'
    )
// 首页显示的分类--goods_index_list
export const goods_index_list =
  () =>
    requestApi(
      '/goods/goods_index_list',
      'GET'
    )
// 首页显示的分类
export const GoodsList =
  (cate_id) =>
    requestApi(
      '/Goods/goods_list?cate_id=' + cate_id,
      'GET'
    )

// 根据ap_id 获取 广告列表
export const getAppadList =
  (apId) =>
    requestApi(
      '/Index/getAppadList',
      'POST',
      {
        'ap_id': apId
      }
    )

// 获取首页需要用到的广告图
export const homeIndexAdList =
  () =>
    requestApi(
      '/Index/getIndexAdList',
      'POST',
      {
      }
    )

// 首页商品列表
export const homeIndexProductList =
  () =>
    requestApi(
      '/Index/getProductList',
      'POST',
      {
      }
    )
// 获取可编辑模块
export const getEditablePageConfigList =
  (pageId, pagePath = '', itemId = 0, storeId = 0) =>
    requestApi(
      '/Index/getEditablePageConfigList',
      'POST',
      {
        editable_page_id: pageId,
        editable_page_path: pagePath,
        editable_page_item_id: itemId,
        store_id: storeId
      }
    )
// 获取猜你喜欢
export const getGuessLike =
  (memberId = 0) =>
    requestApi(
      '/Index/getGuessLike',
      'POST',
      {
        member_id: memberId
      }
    )
